/**
 * Kickard PHASE 4.2.0 — Weekly Cup public read-only client.
 *
 * Weekly Cup is a competitive OVERLAY on completed Ranked matches.
 * No matchmaking, no rooms, no reward logic. This client only ever
 * hits `GET /api/ranked/weekly-cup` and returns the parsed payload.
 * No local scoring, no local sort — all authoritative on the server.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

function _qs(obj) {
  const parts = [];
  Object.keys(obj || {}).forEach((k) => {
    const v = obj[k];
    if (v !== undefined && v !== null && v !== '') {
      parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    }
  });
  return parts.length ? `?${parts.join('&')}` : '';
}

export async function fetchWeeklyCup({ weekStart, limit, guestId } = {}) {
  const q = _qs({ weekStart, limit: limit || 100, guestId });
  try {
    // `cache: 'no-store'` — never render a stale weekly board.
    const r = await fetch(`${BACKEND}/api/ranked/weekly-cup${q}`, { cache: 'no-store' });
    if (!r.ok) {
      const body = await r.json().catch(() => null);
      return { ok: false, status: r.status, code: (body && body.detail && body.detail.code) || 'error' };
    }
    const body = await r.json();
    return { ok: true, ...body };
  } catch (e) {
    return { ok: false, status: 0, code: 'network' };
  }
}

// Phase 4.2.1 — Per-match Weekly Cup contribution for the post-match UI.
// Returns whether the given ranked match counted toward Weekly Cup for
// this guest and, if so, the points awarded + running X/15 progress.
export async function fetchWeeklyCupMatchContribution(matchId, guestId) {
  if (!matchId || !guestId) return { ok: false, code: 'missing_args' };
  const q = _qs({ guestId });
  try {
    const r = await fetch(
      `${BACKEND}/api/ranked/weekly-cup/match/${encodeURIComponent(matchId)}${q}`,
      { cache: 'no-store' },
    );
    if (!r.ok) {
      const body = await r.json().catch(() => null);
      return {
        ok: false,
        status: r.status,
        code: (body && body.detail && body.detail.code) || `http_${r.status}`,
      };
    }
    const body = await r.json();
    return { ok: true, ...body };
  } catch (e) {
    return { ok: false, status: 0, code: 'network' };
  }
}
